import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import BasePage from "../common/base";
import AdminPageContainer from "../../components/admin-components/page-container";
import { AdminDashboardActions } from "../../redux/actions";
import ActionsMenu from "../../components/actions-menu";
import { Button, FormControl, Modal } from "@mui/material";
import MUIDataTable from "mui-datatables";
import dataList from "../../constants/dataList";
import Loading from "../../components/loading";
import OrderFormModal from "./order-form.modal";
import SearchFilter from "../../components/searchFilter";

const BulkOrders = (props: any) => {
  const firstRender = React.useRef(false);
  const [modalOpen, setModalOpen] = React.useState<string>("");
  const [deleteId, setDeleteId] = React.useState(null as any);
  const [filters, setFilters] = React.useState<any>({});
  const [orderToEdit, setOrderToEdit] = React.useState(null as any);
  const [sortOrder, setSortOrder] = React.useState(null as any);
  const [tableStatePersist, setTableStatePersist] = React.useState(null as any);
  const [pagination, setPageState] = React.useState({
    offset: 0,
    limit: props.globalRowsPerPage,
    page: 0,
  });

  const renderActionsMenu: any = (tableMeta: any) => {
    const actionItems = [
      {
        onClick: () => {
          setOrderToEdit(props.orders[tableMeta.rowIndex]);
          setModalOpen("EDIT");
        },
        id: "edit-order",
        title: "Edit",
      },
      // {
      //   onClick: () => {
      //     const thisUser = props.users[tableMeta.rowIndex];
      //     setDeleteId(thisUser.id);
      //     setDeleteEmail(thisUser.email);
      //     setModalOpen("DELETE");
      //   },
      //   id: "delete-user",
      //   title: "Delete",
      // }
    ];
    return <ActionsMenu actionItems={actionItems} />;
  };

  const columnData = [
    {
      label: "Customer",
      name: "customer",
      change: true,
      viewColumns: true,
      display: true,
    },
    {
      label: "Product",
      name: "product",
      change: true,
      viewColumns: true,
      display: true,
    },
    {
      label: "Order Date",
      name: "orderDate",
      change: true,
      viewColumns: true,
      display: true,
    },
    {
      label: "Shipping Address",
      name: "address",
      change: true,
      viewColumns: true,
      display: true,
    },
    {
      label: "Contact Email",
      name: "userEmail",
      change: true,
      viewColumns: true,
      display: true,
    },
    {
      label: "Quantity",
      name: "quantity",
      change: true,
      viewColumns: true,
      display: true,
    },
    {
      label: "Status",
      name: "orderStatus",
      change: true,
      viewColumns: true,
      display: true,
    },
    // {
    //   label: "",
    //   name: "",
    //   change: false,
    //   viewColumns: false,
    //   display: true,
    //   sort: false,
    //   customBodyRender: (value: any, tableMeta: any) => {
    //     return renderActionsMenu(tableMeta);
    //   },
    // },
  ];

  const formatData = (data: any[]) => {
    return data.map((row: any) => {
      const customerObj =
        props.uiCustomers.find(
          (customer: any) => customer.customerId === row.customerId
        ) || {};
      const productObj =
        props.products.find(
          (product: any) => product.sapProductId === row.productId
        ) || {};
      return {
        customer: customerObj.customerName,
        product: productObj.name,
        orderDate: row.createdAt
          ? row.createdAt.replace("T", " ").replace("Z", "UTC")
          : "",
        address: `${customerObj.street} ${customerObj.city}, ${customerObj.state} ${customerObj.zip}`,
        userEmail: row.userEmail,
        quantity: row.quantity,
        orderStatus: row.orderStatus,
      };
    });
  };

  const getTableColumns = () => {
    return columnData.map((column: any, index: number) => {
      return {
        label: column.label,
        name: column.name,
        options: {
          filter: true,
          display: tableStatePersist
            ? tableStatePersist.columns[index].display
            : column.display,
          change: column.change,
          sort: column.sort ?? true,
          viewColumns: column.viewColumns,
          ...(column.customBodyRender && {
            customBodyRender: column.customBodyRender,
          }),
        },
      };
    });
  };

  React.useEffect(() => {
    if (Object.keys(filters).length === 0) filterOrders();
  }, [filters]);

  const getFilter = (reset?: boolean) => {
    let payloadFilter: any = {
      limit: props.globalRowsPerPage,
      offset: pagination.offset,
      order: sortOrder ? [sortOrder] : ["createdAt DESC"],
      where: { and: [] }, //payloadFilters ultimately end up here
    };

    Object.keys(filters).forEach((filterKey: string) => {
      let filterVal: any = filters[filterKey]
        ? [{ [filterKey]: filters[filterKey] }]
        : null;

      if (filterVal) {
        if (filterKey === "customerId") {
          const customer = props.uiCustomers.find(
            (customer: any) => customer.customerName === filters[filterKey]
          );
          filterVal = [
            {
              [filterKey]: customer.customerId,
            },
          ];
        }
        if (filterKey === "createdAt") {
          let date = new Date(filters[filterKey]);
          const start = date.toISOString().split("T")[0];
          date.setDate(date.getDate() + 1);
          const end = date.toISOString().split("T")[0];
          filterVal = [
            { [filterKey]: { gt: start } },
            { [filterKey]: { lt: end } },
          ];
        }
      }
      if (filterVal) {
        payloadFilter.where.and = payloadFilter.where.and.concat(filterVal);
      }
    });

    return JSON.stringify(payloadFilter);
  };

  const filterOrders = (reset?: boolean) => {
    props.getOrders(getFilter(reset));
  };

  const showLoadingMsg = () => !props.authUser && props.orders.length === 0;

  const handleModalClose = () => {
    setModalOpen("");
    setOrderToEdit(null);
  };

  const triggerAddModal = () => {
    setOrderToEdit(null);
    setModalOpen("ADD");
  };

  return (
    <BasePage title={"Bulk Orders"}>
      <AdminPageContainer>
        <div>
          {showLoadingMsg() ? (
            <div>
              <Loading message="" />
            </div>
          ) : (
            <div>
              {/* <div className={classes.searchWrap}>

			</div> */}
              <div style={{ marginBottom: "50px" }}>
                {props.uiCustomers.length > 0 && (
                  <SearchFilter
                    config={[
                      {
                        label: "Customer",
                        name: "customerId",
                        type: "autoComplete",
                        selectOptions: props.uiCustomers.map(
                          (customer: any) => ({
                            label: customer.customerName,
                            value: customer.customerName,
                          })
                        ),
                        renderOptionLabel: (option: any) => {
                          return option.value;
                        },
                      },
                      {
                        label: "Contact Email",
                        name: "userEmail",
                        type: "text",
                      },
                      {
                        label: "Order Date",
                        name: "createdAt",
                        type: "date",
                      },
                      {
                        label: "Quantity",
                        name: "quantity",
                        type: "number",
                      },
                      {
                        label: "Status",
                        name: "orderStatus",
                        type: "autoComplete",
                        selectOptions: [
                          { value: "created" },
                          { value: "open" },
                          { value: "rejected" },
                          { value: "partially shipped" },
                          { value: "fully shipped" },
                        ],
                        renderOptionLabel: (option: any) => {
                          return option.value;
                        },
                      },
                    ]}
                    onFilterChange={setFilters}
                    filters={filters}
                    handleSearch={() => filterOrders()}
                    resetFilters={() => setFilters({})}
                  />
                )}
              </div>

              <div>
                <FormControl>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      triggerAddModal();
                    }}
                  >
                    Create Order
                  </Button>
                </FormControl>
              </div>
              <div style={{ marginTop: 20 }}>
                <MUIDataTable
                  data={formatData(props.orders)}
                  columns={getTableColumns()}
                  options={{
                    rowsPerPage: props.globalRowsPerPage,
                    rowsPerPageOptions: dataList.PageLimitOptions,
                    onChangeRowsPerPage: (numberOfRows: number) => {
                      setPageState({ ...pagination, limit: numberOfRows });
                    },
                    filterType: "dropdown",
                    responsive: "simple",
                    filter: false,
                    search: false,
                    download: true,
                    print: true,
                    selectableRows: "none",
                    serverSide: false,
                    page: pagination.page,
                    onColumnSortChange: (
                      changedColumn: string,
                      direction: string
                    ) => {
                      setSortOrder(
                        `${changedColumn} ${direction.toUpperCase()}`
                      );
                    },
                    onTableChange: (tableAction: any, tableState: any) => {
                      switch (tableAction) {
                        case "changePage":
                          if (tableState.page > pagination.page) {
                            setPageState({
                              offset:
                                pagination.offset + props.globalRowsPerPage,
                              limit: props.globalRowsPerPage,
                              page: tableState.page,
                            });
                          } else if (tableState.page < pagination.page) {
                            setPageState({
                              offset:
                                pagination.offset - props.globalRowsPerPage,
                              limit: props.globalRowsPerPage,
                              page: tableState.page,
                            });
                          }
                          break;
                        case "viewColumnsChange":
                          setTableStatePersist(tableState);
                          break;
                      }
                    },
                  }}
                />
              </div>
              <Modal
                open={["EDIT", "ADD"].includes(modalOpen)}
                onClose={(e: any, reason: string) => {
                  if (reason === "backdropClick") return;
                  handleModalClose();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
              >
                <div>
                  <OrderFormModal
                    getOrders={filterOrders}
                    order={orderToEdit}
                    updateOrder={props.updateOrder}
                    createOrder={props.createOrder}
                    closeModal={handleModalClose}
                  />
                </div>
              </Modal>
            </div>
          )}
        </div>
      </AdminPageContainer>
    </BasePage>
  );
};

const mapStateToProps = (state: any) => ({
  authUser: state.userManagement.authUser,
  orders: state.adminDashboard.bulkOrders
    ? state.adminDashboard.bulkOrders
    : [],
  customers: state.adminDashboard.customers
    ? state.adminDashboard.customers
    : [],
  products: state.adminDashboard.products ? state.adminDashboard.products : [],
  uiCustomers: state.ui.customers || [],
});

const mapDispatchToProps = (dispatch: any) => ({
  getOrders: (filter: any) =>
    dispatch(AdminDashboardActions.getBulkOrders(filter)),
  updateOrder: (payload: any) =>
    dispatch(AdminDashboardActions.updateBulkOrder(payload)),
  createOrder: (payload: any) =>
    dispatch(AdminDashboardActions.createBulkOrder(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkOrders);
